import React, { ReactElement } from 'react'
import StepFileUpload from '../upload/StepFileUpload'
import useUploadHook from '../../hooks/UseUploadHook'
import { IUploadProps } from '../../interfaces/Upload'

const index = 0
function LocativeUpload(props: IUploadProps): ReactElement {
  const { state, setState, validateFile, isPeriodicRemediation } = props
  const { uploadFile } = useUploadHook({
    index,
    setState,
    mainState: state,
    validateFile,
    isPeriodicRemediation,
  })
  const { toggleValidateButton, validationButtonError } = state[index]

  return (
    <div className="col12">
      <div className="row">
        <div className="colXl6 mt3 mt6lg pr3lg">
          <div className="mb2">
            Veuillez nous transmettre un justificatif de domicile
            <p className="fontStyleIt fontSizeXs textPrimaryDark">
              En priorité dernier Avis d’imposition, par exception facture
              gaz/eau/électricité de moins de 6 mois ou échéancier établi pour
              l&apos;année en cours.
            </p>
          </div>

          <StepFileUpload
            {...{
              ...props,
              index,
              title: 'Justificatif de domicile',
              tooltip: 'justificatifDomicile',
              loadingSpinnerClassName: 'dFlex justifyContentEnd',
            }}
          />
          {toggleValidateButton && (
            <>
              <div className="textRight">
                <button
                  className="btn btnPrimary btnPrimaryMd wFull wAutoSm"
                  type="button"
                  onClick={uploadFile}
                >
                  Valider les documents
                </button>
              </div>
              {validationButtonError && (
                <p
                  className={`textRight mt1 ${validationButtonError.type}Error`}
                >
                  {validationButtonError.message}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default LocativeUpload
